<template>
  <div class="flex flex-col" :class="label && 'gap-1'">
    <label v-if="label" :for="id" class="text-base">{{ label }} </label>
    <Multiselect :class="'bg-white! shadow-none! border! border-divider!'" v-bind="$attrs" />
  </div>
</template>

<script setup>
import Multiselect from "@vueform/multiselect";

defineProps({ label: String, id: String });
</script>
